const from_server = {
    members: 1650003,
    competitions: 35,
    comp_winners: 1002,
    regions: 43,
    found_job: 3e5,
    very_glad: 40,
    glad: 37,
    upset: 4,
    neutral: 19,
};

export default {
    state: {
        statistics: {},
    },
    mutations: {
        writeStats: (state, statistics) => state.statistics = statistics,
    },
    actions: {
        loadStatistics: ctx => {
            const on_response = () => ctx.commit('writeStats', from_server);

            setTimeout(on_response, 500);
        },
    },
    getters: {
        statistics: state => state.statistics,
    },
};
